import { Layout, theme, Button, Space, Modal, Menu } from "antd";
import { getCurrentUser, signOut } from "aws-amplify/auth";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { gql, useLazyQuery } from "@apollo/client";
import { GlobalContext } from "./GlobalContextProvider";

const navigators = ["Project", "Support", "Home Page Edit"].map(
  (key, index) => ({
    key,
    label: `${key}`,
  })
);

const GET_TECHNICIAN = gql`
  query MyQuery($id: uuid!) {
    technician_by_pk(id: $id) {
      name
      email
      is_manager
    }
  }
`;

export default function Header(props) {
  const [loginModal, setLoginModal] = useState(false);
  const navigate = useNavigate();

  const {
    menuNavigationPage: currentPage,
    setMenuNavigationPage: setCurrentPage,
    userId,
    userName,
    setUserId,
    setUserName,
    setIsManager,
  } = useContext(GlobalContext);

  const [getTechnician, { error }] = useLazyQuery(GET_TECHNICIAN, {
    variables: { id: userId },
  });
  if (error) {
    console.log(error.message);
  }

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  useEffect(() => {
    async function loginVerification() {
      try {
        const { userId } = await getCurrentUser();

        setUserId(userId);
        const response = await getTechnician({
          variables: { id: userId },
        });
        if (response.data) {
          setUserName(response.data.technician_by_pk.name);
          setIsManager(response.data.technician_by_pk.is_manager);
        }
      } catch (err) {
        console.log(err);
        setLoginModal(true);
      }
    }
    if (!userId) {
      loginVerification();
    }
  }, [
    navigate,
    setLoginModal,
    setUserId,
    userId,
    getTechnician,
    setUserName,
    setIsManager,
  ]);

  const handleSignOut = async () => {
    await signOut();
    navigate("/");
  };

  return (
    // <HeaderSelectionContext.Provider value={setCurrentPage}>
    <Layout style={{ height: "100%" }}>
      <Layout.Header
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "2px",
          background: colorBgContainer,
          position: "sticky",
          top: 0,
          zIndex: 1,
          width: "100%",
        }}
      >
        <img
          src="/RfSonsLogo.png"
          alt="Logo"
          onClick={() => {
            window.location = "/project_list";
          }}
          style={{ width: "128px", height: "40px", marginRight: "32px" }}
        />
        <Menu
          theme="light"
          items={navigators}
          defaultSelectedKeys={currentPage}
          selectedKeys={currentPage}
          onClick={({ key }) => {
            setCurrentPage([key]);
            switch (key) {
              case "Project":
                if (props.deleteTempUpload) {
                  props.deleteTempUpload();
                }
                navigate("/project_list");
                break;
              case "Support":
                navigate("/request_support");
                break;
              case "Home Page Edit":
                navigate("/home_page_edit");
                break;
              default:
                break;
            }
          }}
          mode="horizontal"
          style={{
            borderBottom: "0px",
            display: "flex",
            justifyContent: "flex-end",
            width: "60vh",
          }}
        />
        <Space
          direction="horizontal"
          style={{ width: "100%", justifyContent: "right" }}
        >
          <Button
            type="text"
            onClick={() => {
              handleSignOut();
              // navigate("/user_details", { state: { id: userId } });
            }}
          >
            Hello! {userName}
          </Button>
        </Space>
      </Layout.Header>
      {props.children}
      <Modal
        title="Sign In Required"
        centered
        style={{ textAlign: "center" }}
        open={loginModal}
        onCancel={() => {
          Modal.destroyAll();
        }}
        footer={[
          <Button key="submit" type="primary" onClick={() => navigate("/")}>
            OK
          </Button>,
        ]}
      >
        <p>Please sign in your account</p>
      </Modal>
    </Layout>
  );
}
